import { EvaluationAnswers } from '@/pages/Users/api/services/saveQuestionnaireAnswer';
import { TrainingChecklistTableTypes } from '@/pages/Users/components/TrainingChecklistTable/types';
import { isNil } from '@/utils';

// Seed the evaluation Form's `answers` map from the frozen GetEvaluation snapshot. Works for a single
// category (editable preview) or every category at once (read-only summary).
export const buildAnswersFromCategories = (categories: TrainingChecklistTableTypes.CategoryWithQuestions[] = []): EvaluationAnswers =>
  (categories || [])
    .flatMap((category) => category?.questions || [])
    .reduce((acc, { question }) => {
      acc[question.id] = {
        optionId: question.selectedAnswerOptionId ?? undefined,
        note: question.selectedAnswerNote ?? undefined,
      };
      return acc;
    }, {} as EvaluationAnswers);

export const countCompleted = (answers: EvaluationAnswers): number =>
  Object.values(answers || {}).filter((answer) => !isNil(answer?.optionId)).length;
